import axios from 'axios';
import { type StrapiApiErrorResponse, isStrapiApiErrorResponse } from './isStrapiApiErrorResponse';

const UNKNOWN_ERROR_MESSAGE = 'Unknown error';

// Accepts anything thrown or rejected, not just `Error` instances (antd form validation rejects with a plain object).
export const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error) && isStrapiApiErrorResponse(error.response?.data)) {
    return error.response.data.error.message;
  }

  if (error instanceof Error) return error.message || UNKNOWN_ERROR_MESSAGE;
  if (typeof error === 'string' && error.length > 0) return error;

  return UNKNOWN_ERROR_MESSAGE;
};

export const getErrorDetails = (error: Error): StrapiApiErrorResponse['error']['details'] | undefined => {
  if (axios.isAxiosError(error) && isStrapiApiErrorResponse(error.response?.data)) {
    const { details } = error.response.data.error;

    if (details && Array.isArray(details)) {
      return details;
    }
  }

  return undefined;
};
